import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => {
  const { yellow } = theme.palette.common;

  return {
    leftIcon: {
      marginRight: 30,
    },
    rightIcon: {
      marginLeft: 30,
    },
    root: {
      fontFamily: 'Quicksand, sans-serif !important',
      fontSize: '14px',
      lineHeight: '18px',
      fontWeight: 'bold !important',
      padding: '12px 14px',
    },
    selected: {
      '&.Mui-selected': {
        backgroundColor: yellow,
        color: '#fff',
      },
    },
  };
});
